module.exports = __webpack_public_path__ + "img/icon.6c61dcf5.gif";